import summary from '@/data/summary.json';
import type { Summary } from './types';

// Vite inlines JSON as a typed module. Cast it to our Summary shape.
export const data = summary as unknown as Summary;

export function useData(): Summary {
  return data;
}
